export enum ScheduledQualificationsSortEnum {
    STARTS_AT_ASC = "starts_at",
    STARTS_AT_DESC = "-starts_at",
    ENDS_AT_ASC = "ends_at",
    ENDS_AT_DESC = "-ends_at",
    QUALIFICATION_NAME_ASC = "qualification.name",
    QUALIFICATION_NAME_DESC = "-qualification.name",
    EDUCATOR_NAME_ASC = "educator.name",
    EDUCATOR_NAME_DESC = "-educator.name",
    EMPLOYEE_NAME_ASC = "employee.name",
    EMPLOYEE_NAME_DESC = "-employee.name",
}
